import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from './session.service';

export interface AssinadorStartRequest {
  hashDocumento: string;
  certContent: string;
}

export interface AssinadorStartResponse {
  fileName: string;
  toSignHash: string;
  transferFileId: string;
}

export interface AssinadorCompleteRequest {
  fileToSign: string;
  signature: string;
  transferFileId: string;
  hashDocumento: string;
  nomeUsuario: string;
  cpfUsuario?: string;
  perfilUsuario?: string;
}

export interface AssinadorCompleteResponse {
  hashAssinado: string;
}

@Injectable({ providedIn: 'root' })
export class AssinadorService {
  private urlServer = environment.URL_API;

  constructor(private http: HttpClient, private session: SessionService) {}

  start(payload: AssinadorStartRequest): Observable<AssinadorStartResponse> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.session.token}`,
      'Content-Type': 'application/json',
    });
    return this.http.post<AssinadorStartResponse>(
      `${this.urlServer}/assinador/start`,
      payload,
      { headers }
    );
  }

  complete(payload: AssinadorCompleteRequest): Observable<AssinadorCompleteResponse> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.session.token}`,
      'Content-Type': 'application/json',
    });
    return this.http.post<AssinadorCompleteResponse>(
      `${this.urlServer}/assinador/complete`,
      payload,
      { headers }
    );
  }
}
